import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';

export default function Profile() {
  const { user, updateDisplayName } = useAuth();
  const [name, setName] = useState(user?.name || '');
  const [status, setStatus] = useState(null);
  const [saving, setSaving] = useState(false);

  const displayName = user?.name || user?.email || 'Founder';
  const initial = displayName[0]?.toUpperCase() || '?';

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus(null);
    setSaving(true);
    const result = await updateDisplayName(name);
    setSaving(false);
    setStatus(result.ok ? { type: 'ok', message: 'Name updated.' } : { type: 'error', message: result.message });
  };

  return (
    <div className="min-h-screen" style={{ background: 'var(--brand-bg)' }}>
      <div className="mx-auto max-w-2xl px-4 py-14 sm:px-6 lg:px-8">
        <span className="pill">Account</span>
        <h1 className="page-title section-gap">Your Profile</h1>
        <p className="page-subtitle">Manage how you show up in Tech Dynasty.</p>

        <div className="mt-8 rounded-2xl border border-slate-200 bg-white p-6 shadow-sm sm:p-8">
          <div className="flex items-center gap-4">
            <span className="flex h-16 w-16 shrink-0 items-center justify-center rounded-full bg-gradient-to-br from-[var(--brand-primary)] to-[var(--brand-primary-dark)] text-2xl font-black text-white">
              {initial}
            </span>
            <div className="min-w-0">
              <p className="truncate text-lg font-black text-slate-900">{displayName}</p>
              {user?.email && <p className="truncate text-sm text-slate-500">{user.email}</p>}
            </div>
          </div>

          <form className="mt-8 border-t border-slate-100 pt-6" onSubmit={handleSubmit}>
            <div className="form-row">
              <label htmlFor="displayName">Display name</label>
              <input
                id="displayName"
                type="text"
                value={name}
                onChange={(e) => setName(e.target.value)}
                className="input"
                placeholder="Your name"
                required
              />
            </div>

            {status && (
              <p className={`mb-3 text-sm font-semibold ${status.type === 'ok' ? 'text-emerald-600' : 'text-red-600'}`}>
                {status.message}
              </p>
            )}

            <button type="submit" className="btn btn-primary" disabled={saving}>
              {saving ? 'Saving…' : 'Save changes'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
